import PropTypes from 'prop-types'
import React from 'react'

const ClockIcon = ({
   className,
   color,
   width,
   height,
   strokeWidth
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <circle
            fill="none"
            stroke={color}
            strokeMiterlimit="10"
            cx="12"
            cy="12"
            r="11"
         />
         <polyline
            data-color="color-2"
            fill="none"
            strokeMiterlimit="10"
            points="
            12,6 12,12 18,12 "
         />
      </g>
   </svg>
)

ClockIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

ClockIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(ClockIcon)
